/* types.ts */
export enum QuestionType {
  Text = 'Text',
  SingleChoice = 'SingleChoice',
  MultipleChoice = 'MultipleChoice',
}

export interface ScaleOption {
  id: string;
  optionNumber: number;
  description: string;
}

export interface EvaluationScale {
  id: string;
  title: string;
  scaleOptions: ScaleOption[];
}

export interface Question {
  id: string;
  text: string;
  type: QuestionType;
  order?: number;
  evaluationScale?: EvaluationScale | null;
  metadata?: Record<string, any> | null;
}

export interface Section {
  id: string;
  name: string;
  description?: string | null;
  order: number;
  questions: Question[];
  metadata?: Record<string, any> | null;
}

export interface Survey {
  id: number;
  title: string;
  description?: string | null;
  startDate: string;
  endDate: string;
  context?: string;
  status?: string;
  sections: Section[];
}
